import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Typography } from 'amphitheatre';

import data from './updates.json';
import UpdateBoard from '../../UpdateBoard';
import { CardContainer, Wrapper } from './Updates.styled';

import Update1 from './Update1';
import Update2 from './Update2';
import Update3 from './Update3';

import QFB from './QFB.png';
import Overpass from './pic3.png';

const { Header } = Typography;
const { updates } = data;

const Default: React.FunctionComponent = () => {
  return (
    <div id="update-container">
      <Container size="lg">
        <Header>Updates</Header>
        <CardContainer>
          {updates.map((update) => (
            <UpdateBoard key={update.title} {...update} />
          ))}
        </CardContainer>
      </Container>
    </div>
  );
};

const routes = [
  { path: '/', Component: Default },
  { path: '/welcome', Component: Update1 },
  { path: '/overpass', Component: Update2 },
  { path: '/congratulations', Component: Update3 },
];

const imgIds: Record<string, string> = {
  qfb: QFB,
  overpass: Overpass,
};

updates.forEach((update) => {
  if (update.img) {
    update.img = imgIds[update.img];
  }
});

function Updates(): React.ReactElement {
  const match = useRouteMatch();

  return (
    <Wrapper>
      {routes.map(({ path, Component }) => (
        <Route key={path} exact path={`${match.url}${path}`}>
          {({ match }) => (
            <CSSTransition
              in={match !== null}
              timeout={500}
              classNames="page"
              unmountOnExit
            >
              <Component />
            </CSSTransition>
          )}
        </Route>
      ))}
    </Wrapper>
  );
}

export default Updates;
